import { Component, ElementRef, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-unsung-heroes',
    templateUrl: './unsung-heroes.component.html',
    styleUrls: ['./unsung-heroes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnsungHeroesComponent implements OnInit {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    
  }
  ngAfterViewInit(): void {
    const images = this.el.nativeElement.querySelectorAll('img');
    images.forEach((img: HTMLImageElement) => {
      this.renderer.listen(img, 'click', () => {
        const imageUrl = img.src;
        const modalBody = this.el.nativeElement.querySelector('.modal-body');
        if (modalBody) {
          modalBody.innerHTML = `<img src='${imageUrl}' class='modal-img w-100'>`;
          const modal = this.el.nativeElement.querySelector('#myModal');
          if (modal) {
            modal.classList.add('show');
          }
        }
      });
    });
  }
}
